
import MeverProductDetail from './components/MeverProductDetail';

export default function MeverDetailPage() {
  return <MeverProductDetail />;
}
